import React from 'react'

export default function Steps({ isIndoor }) {
  const steps = [
    'Pick your food',
    'Choose your drinks',
    'Pay securely',
    isIndoor ? "We'll bring it to your table" : 'Collect your order at the clubhouse'
  ]

  return (
    <ol className="space-y-3" aria-label="How it works">
      {steps.map((step, index) => (
        <li key={index} className="flex items-center gap-3 text-gray-900">
          <span className="flex-shrink-0 w-8 h-8 bg-sky-900 text-white rounded-full flex items-center justify-center text-sm font-bold" aria-hidden="true">
            {index + 1}
          </span>
          <span>{step}</span>
        </li>
      ))}
    </ol>
  )
}
